export const Apiconfig = {
    // Auth 
    contactForm: {
        method: 'POST',
        url: "site/contact/submit"
    },
  contactUS: {
        method: 'POST',
        url: "site/contact-us"
    },
      Getpage: {
        method: "POST",
        url: "site/users/get-page",
    },
      listPage: {
        method: "GET",
        url: "site/users/pagelist",
    },
    landingData: {
        method: "POST",
        url: "site/landing/landingdata"
    },


} as const;